import { ModuleConsts } from 'client/util/Constants';

const { passwordStates } = ModuleConsts.systemUser;

export default {
  getPasswordStatus(systemUser) {
    const {
      active, expired, locked, pending,
    } = passwordStates;

    // @TODO: look at simplifying the if statements
    let passwordState = systemUser.activated ? active : pending;
    if (systemUser.account_locked) {
      passwordState = locked;
    } else if (systemUser.password_expired) {
      passwordState = expired;
    }
    return passwordState;
  },
};
